export type ChargeType = "TAX" | "FEE" | "UNKNOWN"

function isRecord(v: unknown): v is Record<string, unknown> {
  return v != null && typeof v === "object" && !Array.isArray(v)
}

function str(v: unknown): string {
  if (v == null) return ""
  return String(v).trim()
}

/**
 * Classifies an API charge row for billing breakdown (tax vs fee).
 * Safe on partial/unknown payloads.
 */
export function classifyCharge(c: unknown): ChargeType {
  if (!isRecord(c)) return "UNKNOWN"

  const chargeType = str(c.charge_type).toUpperCase()
  if (chargeType === "TAX") return "TAX"
  if (chargeType === "FEE") return "FEE"

  const applyOn = c.apply_on
  if (isRecord(applyOn)) {
    const code = str(applyOn.code).toUpperCase()
    if (code.includes("TAX")) return "TAX"
  }

  const n = str(c.charge_name ?? c.name).toLowerCase()
  if (n.includes("vat") || n.includes("tax") || n.includes("gst")) return "TAX"
  if (!n) return "UNKNOWN"
  return "FEE"
}
